'use strict';

require('angular');

module.exports = angular.module('widgets.cart', [])
    .directive('fcAddtocart', require('./addtocart'))
    .directive('fcCart', require('./cart'))
    .directive('fcCartbadge', require('./cartbadge'))
    .directive('fcOrders', require('./orders'));
